import { MakerCard } from '@app/components/MakerCard';
import styles from '@styles/Maker/makers.module.scss';
import Link from 'next/link';
import React, { FC } from 'react';
import { GetManufacturers } from 'services/graphql/cms';

type ItemManufacture = GetManufacturers['manufacturers_connection']['nodes'][0];
type Props = {
  letter: string;
  items: ItemManufacture[];
};

const MakersWrapper: FC<Props> = ({ letter, items }) => (
  <div className={styles.container} id={`maker-${letter}`}>
    <div className={styles.container__header}>
      <h3 className={styles.header__letter}>{letter}</h3>
      <h4 className={styles.header__count}>({items.length})</h4>
    </div>

    <ul className={styles.container__items}>
      {items.map((maker) => (
        <Link key={maker.lumen_ref_id} href={`/maker/${maker.slug}`}>
          <MakerCard key={maker.documentId} maker={maker} />
        </Link>
      ))}
    </ul>
  </div>
);

export default MakersWrapper;
